import CryptoJS from 'crypto-js';
// Below commented code is for create new Key & IV for future.

// var key = CryptoJS.enc.Hex.parse("000102030405060708090a0b0c0d0e0f");
// var iv = CryptoJS.enc.Hex.parse("101112131415161718191a1b1c1d1e1f");

var key = {
  words: CryptoJS.enc.Base64.parse(
    deobfuscate(import.meta.env.VITE_ENC_DEC_KEY),
  ).words,
  sigBytes: CryptoJS.enc.Base64.parse(
    deobfuscate(import.meta.env.VITE_ENC_DEC_KEY),
  ).sigBytes,
};
var iv = {
  words: CryptoJS.enc.Base64.parse(deobfuscate(import.meta.env.VITE_ENC_DEC_IV))
    .words,
  sigBytes: CryptoJS.enc.Base64.parse(
    deobfuscate(import.meta.env.VITE_ENC_DEC_IV),
  ).sigBytes,
};

const isEncryptionEnabled = () => {
  return import.meta.env.VITE_DATABASE_ENCRYPTION === 'true' ? true : false;
};

/* This function is used to encrypt original string. */
export const encryptData = (decrypted = '') => {
  if (!decrypted) return '';
  if (!isEncryptionEnabled()) return decrypted;
  try {
    const encrypted = CryptoJS.AES.encrypt(decrypted, key, { iv }).toString();
    return `${import.meta.env.VITE_ENC_DEC_SAPERATOR}${encrypted}`;
  } catch (error) {
    console.log('encryptData error', error);
    return decrypted;
  }
};

/* This function is used to decrypt encrypted string. */
export const decryptedData = (encrypted = '') => {
  if (!encrypted) return '';
  if (!isEncryptionEnabled()) return encrypted;
  try {
    const encryptedArray = encrypted.split(
      import.meta.env.VITE_ENC_DEC_SAPERATOR,
    );
    let encryptedText = encrypted;
    if (encryptedArray.length === 2) {
      encryptedText = encryptedArray[1];
    }
    const decrypted = CryptoJS.AES.decrypt(encryptedText, key, {
      iv,
    }).toString(CryptoJS.enc.Utf8);
    if (!decrypted || decrypted.trim() === '') {
      return encrypted;
    }
    return decrypted;
  } catch (error) {
    console.log('decryptedData error', error);
    return encrypted;
  }
};

/* function obfuscate(str) {
  return str ? btoa(str) : '';
} */
function deobfuscate(str) {
  return str ? atob(str) : '';
}
